export default __webpack_public_path__ + "static/media/check_circle_24px.7756c631.svg";